import { Grid } from '@mui/material';
import { Location } from '@nx-smartmonkey/shared/domain';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { CSSProperties } from 'react';

import { AlertIcon } from '../../../../../../assets/svg/create-stops/Alert';
import { SuccessIcon } from '../../../../../../assets/svg/create-stops/Success';
import { WarningIcon } from '../../../../../../assets/svg/create-stops/Warning';
import EditIcon from '../../../../../../assets/svg/EditIcon';
import { Text } from '../../../../../../react-components/Text';
import { ValidateStopStatus } from './ValidateStopsBulk';

interface ValidateStopPillProps {
  rawAddress: string;
  location?: Location;
  status: ValidateStopStatus;
  onClick: () => void;

  containerStyle?: CSSProperties;
}

export const ValidateStopPill = ({ rawAddress, status, location, onClick, containerStyle }: ValidateStopPillProps) => {
  const getIcon = () => {
    switch (status) {
      case `error`:
        return <AlertIcon style={{ width: `22px`, height: `22px` }} />;
      case `successful`:
        return <SuccessIcon style={{ width: `22px`, height: `22px` }} />;
      case `warning`:
        return <WarningIcon style={{ width: `22px`, height: `22px` }} />;
      default:
        return null;
    }
  };

  return (
    <Grid
      key={rawAddress}
      container
      direction="row"
      alignItems="center"
      padding="14px 20px"
      borderBottom={`1px solid ${RoutalPalette.neutral10}`}
      onClick={onClick}
      style={containerStyle}
    >
      {getIcon()}

      <HSpacer medium />

      <Grid container direction="column" flex="1">
        <Grid
          style={{
            minHeight: `1rem`,
            marginBottom: `4px`,
          }}
        >
          <Text>{rawAddress}</Text>
        </Grid>
        <Grid
          style={{
            minHeight: `1rem`,
          }}
        >
          {location ? (
            <Text
              variant="body-large"
              style={{ color: status === `warning` ? RoutalPalette.warning.medium : undefined }}
            >
              {location.label}
            </Text>
          ) : (
            <Text
              variant="body-large"
              intlId="driver.stops.create_stops.add_bulk.validate.error"
              style={{ color: RoutalPalette.error.medium }}
            />
          )}
        </Grid>
      </Grid>

      <HSpacer small />

      <EditIcon />
    </Grid>
  );
};
